import SectionTitle from './section-title';
import Photo from './photo';
import Image from 'next/image';
import Link from 'next/link';
export default function ContentBox({ settings }) {
    return (
        <>
            <div className="content-box mx-4 bg-white max-w-screen-lg bg-opacity-20 my-20 lg:mx-auto rounded-[0.25rem] border-[1px] border-maturity-100 shadow-lg overflow-hidden">
                {/* with photo */}
                {settings.photo.data && (
                    <div className="flex flex-col lg:flex-row">
                        <div className="flex w-full h-96 lg:h-auto lg:w-1/2 relative">
                            <Image
                                src={settings.photo.data.attributes.url}
                                alt={settings.photo.data.attributes.alternativeText}
                                layout="fill"
                                className='object-cover'
                            />
                        </div>
                        <div className="flex flex-col text-center w-full lg:w-1/2 lg:text-justify p-10 md:p-20 ">
                            {settings.title && <h3 className="text-trust-500 text-2xl mb-4">{settings.title}</h3>}
                            {settings.content && (
                                <span dangerouslySetInnerHTML={{ __html: settings.content }}></span>
                            )}

                            {settings.buttons && settings.buttons.map((button) => (
                                <Link key={`content-box-button-${button.id}`}
                                    href={button.link}
                                >
                                    <a
                                        title={button.label}
                                        className={`btn mt-4 btn-lg ${button.style}`}
                                    >
                                        {button.label}
                                    </a>
                                </Link>
                            ))}
                        </div>
                    </div>
                )}

                {/* without photo */}
                {!settings.photo.data && (
                    <div className="flex flex-col">
                        {settings.title && <h3 className="text-trust-500 text-2xl ">{settings.title}</h3>}
                        {settings.content && (
                            <span dangerouslySetInnerHTML={{ __html: settings.content }}></span>
                        )}
                        {settings.buttons && settings.buttons.map((button) => (
                            <Link key={`content-box-button-${button.id}`}
                                href={button.link}
                            >
                                <a
                                    title={button.label}
                                    className={`btn mt-4 btn-lg ${button.style}`}
                                >
                                    {button.label}
                                </a>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
}
